import {useTranslation} from "next-i18next"
import Image from "next/image"
import React, {useContext, useEffect, useMemo, useState} from "react"
import LayoutContext from "../../../context/LayoutContext"
import Typography from "../../reusable/Typography/Typography"
import Dropdown from "../../reusable/components/Dropdown/Dropdown"
import {useRouter} from "next/router"

const views = [
	{
		title: "Grid",
		icon: "/assets/icons/componentsIcons/grid.svg",
		iconOnHover: "/assets/icons/componentsIcons/grid-white.svg"
	},
	{
		title: "List",
		icon: "/assets/icons/componentsIcons/list.svg",
		iconOnHover: "/assets/icons/componentsIcons/list-white.svg"
	}
]

export const CollectionViewSelector = () => {
	const {t} = useTranslation(["filters"])

	const {
		isListView,
		isGridView,
		setGridViewCollectionPage,
		setListViewCollectionPage
	} = useContext(LayoutContext)

	const getView = useMemo(() => {
		return isGridView ? "Grid" : isListView ? "List" : "Grid"
	}, [isGridView])
	const [activeView, setActiveView] = useState(getView)

	const [isOpen, setIsOpen] = useState(false)
	const router = useRouter()
	const {query} = router

	const handleViewClick = viewType => {
		setActiveView(viewType)
		setIsOpen(false)
		if (viewType === "Grid") {
			setGridViewCollectionPage()
		} else if (viewType === "List") {
			setListViewCollectionPage()
		}
	}

	const handleMouseEnter = () => {
		setIsOpen(true)
	}

	const handleMouseLeave = () => {
		setIsOpen(false)
	}

	useEffect(() => {
		setActiveView(getView)
		setGridViewCollectionPage()
	}, [])

	return (
		<>
			<div className="row gx-2 mx-0 px-0 align-items-center d-md-none"
			>
				{views?.map((view, index) => (
					<div key={index}
						onClick={() => handleViewClick(view.title)}
						className={"col-auto py-md-2"}>
						<div className="d-flex align-items-center px-3 py-2"
							style={{
								background: activeView === view.title ? "#212529" : "#F8F8F8",
								borderRadius: 16,
								color: activeView === view.title ? "#fff" : "#212529",
								cursor: "pointer"
							}}>
							<div className="position-relative"
								style={{
									width: 24,
									height: 24
								}}>
								<Image src={view.title === activeView ? view.iconOnHover : view.icon}
									layout={"fill"}/>
							</div>
							<Typography className="ms-2"
								variant={activeView === view.title ? "bodyLgBold" : "bodySm"}
								semanticTag="span">{t(view.title)}</Typography>
						</div>
					</div>
				))}
			</div>
			<div className="d-none d-md-flex align-items-center position-relative">
				<Typography variant="bodySmBold"
					semanticTag="span"
					className="me-2 pe-1">
					{`${t("select-view-title")}:`}
				</Typography>
				{query.categories === "zubehoer" ?
					<Typography variant={"bodyLg"}
						semanticTag="span">{t("Grid")}</Typography> :
					<div className="d-flex align-items-center cursor-pointer"
						onMouseEnter={handleMouseEnter}
						onMouseLeave={handleMouseLeave} >
						<Typography variant="bodySm"
							semanticTag="span"
							className="me-2 pe-1">
							{t(activeView)}
						</Typography>
						<Image src="/assets/icons/chevron-down.svg"
							alt="arrow down"
							width={12}
							height={6.5}/>
						<Dropdown top={20}
							left={-40}
							isOpen={isOpen}
							height={40}>
							<ul style={{minWidth: "204px"}}
								className="bg-white border px-2 py-2 row rounded rounded-2 shadow list-unstyled">
								{views.map(view =>
									<div key={view.title}
										className={"p-2 view-selector-dropdown-item"}
										onClick={() => handleViewClick(view.title)}>
										<Typography variant={"bodyLg"}
											semanticTag="span"
											className={"cursor-pointer "}>{t(view.title)}</Typography>
									</div>
								)}
							</ul>
						</Dropdown>
					</div>
				}
			</div>
		</>
	)
}
